import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Inject, Input, Output, ViewContainerRef, ViewEncapsulation } from '@angular/core';
import { Subscription } from 'rxjs';

import { IMCMapView } from '../../classes/mcMapView';
import { ESRI } from '../../esri-loader-util';
import { BooleanConverter } from '../../inputConverter';
import { IAuthenticationService } from '../../services/interfaces/IAuthenticationService';
import { IUserSettingsService } from '../../services/interfaces/IUserSettingsService';
import { BaseComponent } from '../base.component';

let Extent: __esri.ExtentConstructor;

@Component({
    encapsulation: ViewEncapsulation.ShadowDom,
    selector: 'mc-bookmark',
    styleUrls: ['../sharedStyles/base.scss', './bookmark.component.scss'],
    templateUrl: './bookmark.component.html'
})
export class BookmarkComponent extends BaseComponent implements AfterViewInit {
    private _active: boolean = false;
    @Input() set active(value: boolean) {
        this._active = BooleanConverter(value);
        value ? this.activate() : this.deactivate();
        this.activeChange.emit(value);
    }
    get active(): boolean { return this._active; }

    @Input() appName: string;

    @Output() readonly activeChange: EventEmitter<boolean> = new EventEmitter();

    mapView: NonNullable<__esri.MapView>;
    mapRef: IMCMapView;
    userSubscriber: Subscription;
    userEmail: string;
    inputText = null;
    bookmarks: IBookmark[] = [];

    constructor(
        @Inject('authenticationService') private readonly authService: IAuthenticationService,
        @Inject('UserSettingsService') public UserSettingsService: IUserSettingsService,
        private readonly changeDetectorRef: ChangeDetectorRef,
        _vcr: ViewContainerRef) {
        super(_vcr, true);
    }

    async ngAfterViewInit() {
        if (!this.mapView) {
            this.mapView = await this.setupMapViewRef(this.mapView);
            this.isReady();
        }
        Extent = await ESRI.Extent;
    }

    private async activate() {
        if (!this.userSubscriber) {
            this.userSubscriber = await this.authService.GetCurrentUser().subscribe(user => {
                if (user && user.id) {
                    this.userEmail = user.emailAddress;
                    this.loadUserSettings();
                }
            });
        }
    }

    private deactivate(): void {
        this.userSubscriber.unsubscribe();
        this.userSubscriber = undefined;
    }

    async loadUserSettings() {
        this.mapRef = await this.setupMapViewRef(this.mapView);

        this.UserSettingsService.GetSettingValue('bookmarks', this.appName, this.userEmail).subscribe(results => {
            this.bookmarks = results || [];
            this.changeDetectorRef.detectChanges();
        });
    }

    saveBookmark() {
        this.bookmarks.push({ name: this.inputText, extent: this.mapView.extent.toJSON() });
        this.inputText = null;
        this.saveSettings();
    }

    async saveSettings() {
        await this.UserSettingsService.SetSettingValue('bookmarks', this.bookmarks, this.userEmail, this.appName);
        this.changeDetectorRef.detectChanges();
    }

    deleteExtent(index) {
        this.bookmarks.splice(index, 1);
        this.saveSettings();
    }

    goToExtent(index) {
        this.mapView.goTo(Extent.fromJSON(this.bookmarks[index].extent), { animate: true });
    }
}

interface IBookmark {
    name: string;
    extent: any;
}
